export class GestorDTO {
    constructor(
        public login?: string,   
        public nome?: string, 
        public cpf?: string,
        public senha?: string,
    ) { 
    }
}